import { render } from "./ProfileRequest.view.vue?vue&type=template&id=e9791e3e"
import script from "./ProfileRequest.view.vue?vue&type=script&lang=js"
export * from "./ProfileRequest.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__